import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { toast } from 'react-toastify';
import TicketSalesGauge from './TicketSalesGauge';
import { Edit01 } from '@opendate-app/setlist';
import Popup from "reactjs-popup";
import { handleSetPermissions } from '../utils/permissionsHelper';
import PageSectionMenu from './PageSectionMenu';
import { SectionTitle } from './ClassicSectionCard';
import TicketPreviewModal from './TicketPreviewModal';

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const popupContentStyle = {
  "background": "var(--sl-bg-primary)",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "230px",
  "padding": "0px"
}

const calculatePercentageSold = (confirm) => {
  var ticketsSold = confirm.number_of_manifested_tickets_sold;
  var venueCapacity = confirm.venue_capacity;

  if(venueCapacity === 0){
    return (ticketsSold > 0 ? 100 : 0);
  }

  return Math.ceil((ticketsSold / venueCapacity) * 100);
}

const filteredTicketTypes = (ticketTypesByPrice, currentUser) => {
  if(currentUser.can_see_unmanifested_tickets){
    return ticketTypesByPrice;
  } else {
    return ticketTypesByPrice.filter((sd) => sd.ticket_type.manifested);
  }
}

const ManageOpendateTickets = ({
  csrfToken,
  team,
  confirm,
  confirmChanged,
  updateConfirmTicketForecast,
  currentUser,
  ticketTypesByPrice,
  showWidgetCodeChanged,
  addOnsByPrice,
  manualTicketCounts,
  confirmPageSection,
  fetchPermissionSet,
  updateConfirmPageSection
}) => {
  const [ticketPreviewModalOpen, setTicketPreviewModalOpen] = useState(false);

  return (
  <div className="card no-border shadow-2">
    <div className="card-body px-md-3">
      {confirm.published_at || manualTicketCounts.length > 0 ? (
        <React.Fragment>
          <div className="row">
            <div className="col">
              <strong style={{"fontSize": "16px"}}>
                Tickets
                {confirmPageSection.permission_set_id ? (
                  <i className="ml-2 far fa-lock small text-danger"></i>
                ) : null}
              </strong>
              {currentUser.can_manage_ticket_types && confirm.published_at ? (
                <a href={"/teams/" + team.id + "/confirms/" + confirm.id + "/dashboard"}
                   className="btn btn-external btn-sm rounded ml-2">
                  <i className="fas fa-arrow-right"></i>
                </a>
              ) : null}
            </div>
            <div className="col-xs-auto"
                 style={{"paddingRight": "15px", "display": "flex", "alignItems": "center", "gap": "8px"}}>
              {currentUser.can_manage_ticket_types ? (
                <Popup arrow={false}
                       offsetY={5}
                       position="bottom right"
                       contentStyle={popupContentStyle}
                       onOpen={
                         (e) => {
                           e.stopPropagation();
                           e.preventDefault();
                         }
                       }
                       trigger={open => (
                         <a href="#"
                            onClick={
                              (e) => {
                                e.preventDefault();
                              }
                            }
                            className="btn btn-external btn-sm">
                           <i className="fas fa-ellipsis-v"></i>
                         </a>
                       )} >
                  {close => (
                    <div className='row text-left'>
                      <div className="col-12">
                        <ul className="list-group offer-inline-menu">
                          <li className="list-group-item px-3 pt-3 pb-2">
                            <a href={"/teams/" + team.id + "/confirms/" + confirm.id + "/ticketing"}
                               className="text-dark">
                              <span className="d-inline-block text-center" style={{width: "28px"}}>
                                <i className="fas fa-pencil fa-fw"></i>
                              </span>
                              <span className="ml-3">
                                Edit tickets
                              </span>
                            </a>
                          </li>
                          {false ? (
                              <li className="list-group-item px-3 py-2">
                                <a href="#"
                                   className="text-dark"
                                   onClick={
                                     (e) => {
                                       e.preventDefault();
                                       close();
                                       // fetchNewTicketType(csrfToken, team, ticketType);
                                     }
                                   }>
                                  <span className="d-inline-block text-center" style={{width: "28px"}}>
                                    <i className="far fa-arrow-to-bottom fa-fw"></i>
                                  </span>
                                  <span className="ml-3">
                                    Download report
                                  </span>
                                </a>
                              </li>
                          ) : null}
                          {confirm.published_at ? (
                            <li className="list-group-item px-3 pt-2 pb-2">
                              <a href="#"
                                className="text-dark"
                                onClick={
                                  (e) => {
                                    e.preventDefault();
                                    close();
                                    showWidgetCodeChanged(true);
                                  }
                                }>
                                <span className="d-inline-block text-center" style={{width: "28px"}}>
                                  <i className="far fa-code fa-fw"></i>
                                </span>
                                <span className="ml-3">
                                  Embed widget
                                </span>
                              </a>
                            </li>
                          ) : null}
                          {currentUser.role.name === "Administrator" ? (
                            <li className="list-group-item px-3 pt-2 pb-2">
                              <a href="#"
                                 onClick={
                                   (e) => {
                                     e.preventDefault();
                                     close();
                                     handleSetPermissions(
                                       confirmPageSection,
                                       team,
                                       fetchPermissionSet,
                                       updateConfirmPageSection
                                     );
                                   }
                                 }
                                 className="text-dark">
                                <span className="d-inline-block text-center" style={{width: "28px"}}>
                                  <i className="far fa-user-lock fa-fw"></i>
                                </span>
                                <span className="ml-3">
                                  Set Permissions
                                </span>
                              </a>
                            </li>
                          ) : null}
                          {confirm.published_at ? (
                            <li className="list-group-item px-3 pt-2 pb-2">
                              <a href={"/teams/" + team.id + "/confirms/" + confirm.id + "/ticket_audit"}
                                 className="text-dark">
                                <span className="d-inline-block text-center" style={{width: "28px"}}>
                                  <i className="far fa-clipboard-list fa-fw"></i>
                                </span>
                                <span className="ml-3">
                                  View Ticket Audit
                                </span>
                              </a>
                            </li>
                          ) : null}
                          <li className="list-group-item px-3 pt-2 pb-3">
                            <a href="#"
                               className="text-dark"
                               onClick={(e) => {
                                 e.preventDefault();
                                 close();
                                 setTicketPreviewModalOpen(true);
                               }}>
                              <span className="d-inline-block text-center" style={{width: "28px"}}>
                                <i className="far fa-ticket fa-fw"></i>
                              </span>
                              <span className="ml-3">
                                View Ticket Header
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </Popup>
              ) : null}
            </div>
          </div>
          <div>
            <TicketSalesGauge sold={confirm.number_of_manifested_tickets_sold || 0}
                              capacity={confirm.venue_capacity || 0}
                              percentage={calculatePercentageSold(confirm)}
                              forecast={confirm.ticket_forecast} />
            <div className="ticket-sales-stats">
              <div className="ticket-sales-stats__cell">
                <div className="ticket-sales-stats__label">Forecast</div>
                <div className="ticket-sales-stats__value">
                  {confirm.editingTicketForecast ? (
                    <>
                      <input
                        type="number"
                        style={{
                          "color": "var(--sl-text-primary)",
                          "width": "100px",
                          "border": "0px",
                          "outline": "none",
                          "boxShadow": "none",
                          "fontSize": "var(--setlist-text-xl-size)",
                          "fontWeight": "600",
                          "background": "transparent",
                          "padding": "0px"
                        }}
                        value={confirm.editedTicketForecast || confirm.ticket_forecast || 0}
                        onChange={e => {
                          confirmChanged({
                            ...confirm,
                            editedTicketForecast: e.target.value
                          });
                        }}
                      />
                      <a
                        href=""
                        style={{"fontSize": "14px"}}
                        className="ml-2 text-muted"
                        onClick={e => {
                          e.preventDefault();

                          updateConfirmTicketForecast(
                            csrfToken,
                            confirm,
                            confirm.editedTicketForecast || confirm.ticket_forecast,
                            data => { // Success callback
                              confirmChanged({
                                ...confirm,
                                editedTicketForecast: null,
                                editingTicketForecast: false,
                                ticket_forecast: data.ticket_forecast,
                              });

                              toast.success("Ticket forecast updated.", {
                                position: toast.POSITION.TOP_CENTER,
                                draggable: false,
                                closeOnClick: true,
                                autoClose: 5000,
                                hideProgressBar: true
                              });
                            },
                            error => { // Error callback
                              confirmChanged({
                                ...confirm,
                                editedTicketForecast: null,
                                editingTicketForecast: false
                              });

                              var message = typeof error.response === 'undefined'
                                ? "Something went wrong"
                                : error.response.data.join(', ');

                              toast.error(message, {
                                position: toast.POSITION.TOP_CENTER,
                                draggable: false,
                                closeOnClick: false,
                                autoClose: 5000,
                                hideProgressBar: true
                              });
                            }
                          );
                        }}
                      >
                        <i className="fas fa-check"></i>
                      </a>
                      <a
                        href=""
                        style={{"fontSize": "14px"}}
                        className="ml-2 text-muted"
                        onClick={e => {
                          e.preventDefault();

                          confirmChanged({
                            ...confirm,
                            editedTicketForecast: null,
                            editingTicketForecast: false
                          });
                        }}
                      >
                        <i className="fas fa-xmark"></i>
                      </a>
                    </>
                  ) : (
                    <>
                      {confirm.ticket_forecast || 0}
                      <a
                        href=""
                        style={{"fontSize": "14px"}}
                        className="ml-2 text-muted"
                        onClick={e => {
                          e.preventDefault();

                          confirmChanged({...confirm, editingTicketForecast: true});
                        }}
                      >
                        <Edit01 width={16} height={16} aria-label="Edit forecast" />
                      </a>
                    </>
                  )}
                </div>
              </div>
              {currentUser.can_see_unmanifested_tickets ? (
                <div className="ticket-sales-stats__cell">
                  <div className="ticket-sales-stats__label">Issued</div>
                  <div className="ticket-sales-stats__value">{confirm.number_of_tickets_issued}</div>
                </div>
              ) : null}
            </div>
            <div className="row">
              <div className="col-12">
                <div className="table-responsive">
                <table className="table table-sm table-borderless vertical-middle mt-0 ticket-sales-table">
                  <tbody>
                    {filteredTicketTypes(ticketTypesByPrice, currentUser).map((salesData, index) => (
                      <tr key={index}
                          style={{"borderBottom": "2px solid var(--od-c-eeeeee, #efefef)"}}
                          className={(salesData.ticket_type.scheduled ? "text-muted" : "")}>
                        <td className="py-2 ticket-sales-table__name">
                          <strong title={salesData.product_name}>
                            {salesData.product_name}
                          </strong>
                          {salesData.ticket_type.scheduled ? (
                            <p className='mb-0 small'
                               title={salesData.ticket_type.sales_timeline ? (salesData.ticket_type.sales_timeline) : ""}>
                              <span>Scheduled </span>
                              {salesData.ticket_type.sales_timeline ? (
                                salesData.ticket_type.sales_timeline
                              ) : null}
                            </p>
                          ) : null}
                        </td>
                        <td className="py-2 text-right ticket-sales-table__number">
                          {salesData.quantity}/{salesData.ticket_type.available}
                        </td>
                        <td className="py-2 text-right ticket-sales-table__number">
                          {parseFloat(salesData.price) !== 0 ? (
                            formatter.format(salesData.price)
                          ) : (
                            "Free"
                          )}
                        </td>
                      </tr>
                    ))}
                    {manualTicketCounts.map((manualTicketCount, index) => (
                      <tr key={index}
                          style={{"background": "var(--od-c-f9f9f9, #F9F9F9)"}}>
                        <td className="py-2 ticket-sales-table__name">
                          <p className='text-muted mb-0' style={{"fontSize": "10px"}}>
                            EXTERNAL TICKET
                          </p>
                          <p className='mb-0' style={{"marginTop": "-3px"}}>
                            <strong title={manualTicketCount.name}>
                              {manualTicketCount.name}
                            </strong>
                          </p>
                        </td>
                        <td className="py-2 text-right ticket-sales-table__number">
                          {typeof(manualTicketCount.available) === "number" ? (
                            <span>{manualTicketCount.quantity}/{manualTicketCount.available}</span>
                          ) : (
                            <span>{manualTicketCount.quantity}</span>
                          )}
                        </td>
                        <td className="py-2 text-right ticket-sales-table__number">
                          {parseFloat(manualTicketCount.price) !== 0 ? (
                            formatter.format(manualTicketCount.price)
                          ) : (
                            "Free"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
                {addOnsByPrice.length > 0 ? (
                  <React.Fragment>
                    <p className="text-muted"
                       style={{
                         "paddingTop": "3px",
                         "marginBottom": "10px"
                       }}>
                      <strong>
                        ADD-ONS
                      </strong>
                    </p>
                    <div className="table-responsive">
                    <table className="table table-sm table-borderless vertical-middle mt-0 ticket-sales-table">
                      <tbody>
                        {addOnsByPrice.sort((a, b) => a.add_on.position - b.add_on.position).map((salesData, index) => (
                          <tr key={index}
                              style={{"borderBottom": "2px solid var(--od-c-eeeeee, #efefef)"}}
                              className={(salesData.add_on.scheduled ? "text-muted" : "")}>
                            <td className="py-2 ticket-sales-table__name">
                              <strong title={salesData.product_name}>
                                {salesData.product_name}
                              </strong>
                              {salesData.add_on.scheduled ? (
                                <p className='mb-0 small'
                                   title={salesData.add_on.sales_timeline ? (salesData.add_on.sales_timeline) : ""}>
                                  <span>Scheduled </span>
                                  {salesData.add_on.sales_timeline ? (
                                    salesData.add_on.sales_timeline
                                  ) : null}
                                </p>
                              ) : null}
                            </td>
                            <td className="py-2 text-right ticket-sales-table__number">
                              {salesData.quantity}/{salesData.add_on.available}
                            </td>
                            <td className="py-2 text-right ticket-sales-table__number">
                              {formatter.format(salesData.price)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                  </React.Fragment>
                ) : null}
              </div>
            </div>
            <div className="row mt-1">
              <div className="col-xs-auto text-muted"
                   style={{"paddingLeft": "15px"}}>
                Event ID: <a href={"/teams/" + team.id + "/confirms/" + confirm.id}>{confirm.id}</a>
              </div>
              <div className="col text-right text-muted">
                Powered by
                <img src="/opendate-horiz-wh.png"
                     style={{"width": "85px"}}
                     className="img-fluid ml-2" />
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="row">
            <div className="col">
              <SectionTitle title="Tickets"
                            locked={Boolean(confirmPageSection && confirmPageSection.permission_set_id)} />
            </div>
            <div className="col-xs-auto" style={{"paddingRight": "15px"}}>
              <PageSectionMenu csrfToken={csrfToken}
                               team={team}
                               confirm={confirm}
                               currentUser={currentUser}
                               confirmPageSection={confirmPageSection}
                               fetchPermissionSet={fetchPermissionSet}
                               updateConfirmPageSection={updateConfirmPageSection} />
            </div>
          </div>
          <div className="row pt-3">
            <div className="col-12">
              <div className="card no-border mb-0" style={{'background': 'var(--od-c-f3f9fc, #f4f9fc)'}}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-12 text-center">
                      <i className="fal fa-ticket-alt"
                         style={{
                           "fontSize": "60px",
                           "marginTop": "24px",
                           "color": "rgba(25, 130, 196, .5)"
                         }}>
                      </i>
                      <h5 className="pt-2"
                          style={{"fontSize": "20px"}}>
                        Create Tickets
                      </h5>
                      <p className="text-muted mt-3 mb-4">
                        You're just a few clicks away.
                      </p>
                      {currentUser.can_manage_ticket_types ? (
                        <a href={"/teams/" + team.id + "/confirms/" + confirm.id + "/ticketing"}
                           className="btn btn-primary small mb-2">
                          <strong>Create Tickets</strong>
                        </a>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
      <TicketPreviewModal
        open={ticketPreviewModalOpen}
        onClose={() => setTicketPreviewModalOpen(false)}
        teamId={team.id}
        confirmId={confirm.id}
      />
    </div>
  </div>
  );
};

ManageOpendateTickets.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  confirmChanged: PropTypes.func.isRequired,
  updateConfirmTicketForecast: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  ticketTypesByPrice: PropTypes.array,
  showWidgetCodeChanged: PropTypes.func.isRequired,
  addOnsByPrice: PropTypes.array,
  manualTicketCounts: PropTypes.array,
  confirmPageSection: PropTypes.object,
  fetchPermissionSet: PropTypes.func.isRequired,
  updateConfirmPageSection: PropTypes.func.isRequired
};

export default ManageOpendateTickets;
